'use client';

import { PageBanner } from '@repo-ui/components/PageBanner';

const BANNER_TINT = '#FFCA28';
const BANNER_BACKGROUND = '#121212';

export default function DtbPageBanner() {
  return (
    <PageBanner
      title="교과목"
      tint={BANNER_TINT}
      background={BANNER_BACKGROUND}
      contrastColor="#222"
      bgImgSrc="/_static/images/page-banner/top_banner1.png"
      breadcrumbProps={{
        tint: '#fff',
        currentTitle: '교과목',
      }}
      sx={{
        '& .PageBanner-title': {
          mb: 5,
        },
      }}
    />
  );
}
